import Head from "next/head";
import { useEffect, useState } from "react";
import { useRouter } from "next/router";

import Boot from "../components/Homepage/redesign/Boot";
import Hero from "../components/Homepage/redesign/Hero";
import Mission from "../components/Homepage/redesign/Mission";
import Registries from "../components/Homepage/redesign/Registries";
import HowItWorks from "../components/Homepage/redesign/HowItWorks";
import Collections from "../components/Homepage/redesign/Collections";
import Marketplace from "../components/Homepage/redesign/Marketplace";
import SpaceNews from "../components/Homepage/redesign/SpaceNews";
import Roadmap from "../components/Homepage/redesign/Roadmap";
import TokenBand from "../components/Homepage/redesign/TokenBand";
import CTABand from "../components/Homepage/redesign/CTABand";

// Resets to false on every full page load (so the first client render matches
// the SSR markup), then stays true for the tab's lifetime — letting subsequent
// client-side navigations read sessionStorage eagerly without a splash flash.
let hydrated = false;

const Home = () => {
  // Boot once per session (skip on subsequent client navigations back home).
  // The first render must default to `true` so SSR and hydration agree;
  // sessionStorage is only safe to read synchronously once we've hydrated.
  const [booting, setBooting] = useState(() => {
    if (!hydrated) return true;
    try { return sessionStorage.getItem("nsky_booted") !== "1"; } catch { return true; }
  });
  const router = useRouter();

  // After hydration, mark it done and skip the splash if it already ran.
  useEffect(() => {
    hydrated = true;
    try {
      if (sessionStorage.getItem("nsky_booted") === "1") setBooting(false);
    } catch {}
  }, []);

  const finishBoot = () => {
    try { sessionStorage.setItem("nsky_booted", "1"); } catch {}
    setBooting(false);
  };

  const openClaim = () => router.push("/real-estate/mars");

  // Scroll-reveal for [data-reveal] elements is handled globally by
  // <SmoothScroll> (GSAP ScrollTrigger) so it stays in sync with Lenis.

  return (
    <>
      <Head>
        <title>NiftySky — Cosmic Marketplace for Real Assets</title>
        <meta
          name="description"
          content="NiftySky tokenizes real astronomical bodies — planets, moons, stars and minor planets — indexed from NASA, IAU & USGS data and recorded on-chain as verifiable deeds."
        />
        <link rel="icon" href="/favicon.ico" />
      </Head>

      {booting && <Boot onDone={finishBoot} />}

      <main>
        <Hero onClaim={openClaim} />
        <Mission />
        <Registries onClaim={openClaim} />
        <HowItWorks />
        <Collections />
        <Marketplace onClaim={openClaim} />
        <SpaceNews />
        <Roadmap />
        <TokenBand />
        <CTABand onClaim={openClaim} />
      </main>
    </>
  );
};

export default Home;
